
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/venison",
      function () {
        return require("private-next-pages/recipes/venison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/venison"])
      });
    }
  